<template>
    <v-container fluid>
        <h3 v-if="$store.state.inscritos.length > 1">Listado de corredores que forman la inscripción</h3>
        <h3 v-else>Datos de la inscripción</h3>
        <v-expansion-panels focusable multiple v-if="$store.state.inscritos.length > 1">
            <v-expansion-panel
                    v-for="persona in getInscritos" :key="persona.dni"
            >
                <v-expansion-panel-header>{{ persona.nombre.toUpperCase() }} {{ persona.apellidos.toUpperCase() }}
                    , <strong>{{calcularParcial(persona.dni)}} €</strong>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-row>
                        <v-col cols="12">
                            <v-simple-table fixed-header >
                                <template v-slot:default>
                                    <thead style="background-color: orange; text-align: center;">
                                    <tr>
                                        <td>Nombre</td>
                                        <td>Apellidos</td>
                                        <td>DNI</td>
                                        <td>Email</td>
                                        <td>Teléfono</td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr style="text-align: center;">
                                        <td>{{ persona.nombre }}</td>
                                        <td>{{ persona.apellidos }}</td>
                                        <td>{{ persona.dni }}</td>
                                        <td>{{ persona.email }}</td>
                                        <td>{{ persona.tlfno }}</td>
                                    </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>

                        <v-col cols="12">
                            <v-simple-table fixed-header >
                                <template v-slot:default>
                                    <thead style="background-color: orange; text-align: center;">
                                    <tr>
                                        <td>Socio de Os Andarines</td>
                                        <td>Categoría</td>
                                        <td>Marca</td>
                                        <td>Camiseta</td>
                                        <td>Talla</td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr style="text-align: center;">
                                        <td>{{ persona.socio }}</td>
                                        <td>{{ getCategoria(persona.idCategoria).nombre }}</td>
                                        <td>{{ persona.marca }}</td>
                                        <td>{{ persona.camiseta }}</td>
                                        <td>{{ persona.talla }}</td>
                                    </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <v-row v-else v-for="persona in getInscritos" :key="persona.dni">
            <v-col cols="12">
                <v-simple-table fixed-header >
                    <template v-slot:default>
                        <thead style="background-color: orange; text-align: center;">
                        <tr>
                            <td>Nombre</td>
                            <td>Apellidos</td>
                            <td>DNI</td>
                            <td>Email</td>
                            <td>Teléfono</td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr style="text-align: center;">
                            <td>{{ persona.nombre }}</td>
                            <td>{{ persona.apellidos }}</td>
                            <td>{{ persona.dni }}</td>
                            <td>{{ persona.email }}</td>
                            <td>{{ persona.tlfno }}</td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>

            <v-col cols="12">
                <v-simple-table fixed-header >
                    <template v-slot:default>
                        <thead style="background-color: orange; text-align: center;">
                        <tr>
                            <td>Socio de Os Andarines</td>
                            <td>Categoría</td>
                            <td>Marca</td>
                            <td>Camiseta</td>
                            <td>Talla</td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr style="text-align: center;">
                            <td>{{ persona.socio }}</td>
                            <td>{{ getCategoria(persona.idCategoria).nombre}}</td>
                            <td>{{ persona.marca }}</td>
                            <td>{{ persona.camiseta }}</td>
                            <td>{{ persona.talla }}</td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
        </v-row>
        <v-row cols="12">
            <v-col cols="12">
                <h3>Total de la inscripción: {{ calcularTotal() }} €</h3>
            </v-col>
        </v-row>

        <v-row v-if="$store.state.inscritos.length > 1">
            <v-col cols="12" sm="12">
                <v-radio-group row label="pagador" v-model="pagaInscrito" @change="cambiaModo">
                    <v-radio label="SI" value="SI"></v-radio>
                    <v-radio label="NO" value="NO"></v-radio>
                    <template v-slot:label>
                        ¿El pago lo realiza uno de los inscritos?
                    </template>
                </v-radio-group>
            </v-col>
            <v-col cols="12" v-if="pagaInscrito=='SI'">
                <v-select
                        :items="pagadores"
                        prepend-icon="payment"
                        label="¿Quién realizará el pago?"
                        item-value="dni"
                        v-model="pagador.persona"
                        return-object
                        @change="establecePagador"
                >
                    <template slot="selection" slot-scope="data">
                        <template>
                            {{data.item.nombre.toUpperCase() }} {{ data.item.apellidos.toUpperCase() }}
                        </template>
                    </template>
                    <template slot="item" slot-scope="data" >
                        <template>
                            {{data.item.nombre.toUpperCase() }} {{ data.item.apellidos.toUpperCase() }}
                        </template>
                    </template>
                </v-select>
            </v-col>



        </v-row>
        <v-form  v-if="pagaInscrito=='NO'"
                 ref="form"
                 lazy-validation
        >
            <v-content>
                <v-col cols="12" xs="12">
                    <h3>Por favor, introduzca los datos del pagador</h3>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                    <v-text-field
                            prepend-icon="face"
                            v-model="pagaAnonimo.nombre"
                            required
                            :rules="nombreRules"
                            maxlength="150"
                    >
                        <template v-slot:label>
                            Nombre completo<sup>
                            <v-icon small>priority_high</v-icon>
                        </sup>
                        </template>
                    </v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="4">
                    <v-text-field
                            prepend-icon="fingerprint"
                            v-model="pagaAnonimo.dni"
                            required
                            :rules="dniRules"
                            maxlength="9"
                    >
                        <template v-slot:label>
                            DNI<sup>
                            <v-icon small>priority_high</v-icon>
                        </sup>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                    <v-text-field
                            prepend-icon="email"
                            v-model="pagaAnonimo.email"
                            required
                            :rules="emailRules"
                            maxlength="150"
                    >
                        <template v-slot:label>
                            Email<sup>
                            <v-icon small>priority_high</v-icon>
                        </sup>
                        </template>
                    </v-text-field>

                </v-col>
                <v-col cols="12" sm="6" md="4">
                    <v-btn large dark color="success" @click="otroPagador">
                        Establecer como pagador
                    </v-btn>
                </v-col>
            </v-content>

        </v-form>

        <v-row>
            <v-col cols="6">
                <form v-if="tpv" :action="tpv.url" method="POST" ref="frmPago">
                    <input type="hidden" name="Ds_SignatureVersion" :value="tpv.version">
                    <input type="hidden" name="Ds_MerchantParameters" :value="tpv.params">
                    <input type="hidden" name="Ds_Signature" :value="tpv.signature">
                </form>
                <v-btn block large color="success" @click="pagar" :disabled="!pagarOk || !tpv">Pagar</v-btn>

            </v-col>
            <v-col cols="6">
                <v-btn block large color="info" @click="volver">Volver atrás</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import { cat } from '../config'
    import { mapActions } from 'vuex'
    import moment from 'moment'
    import {insService} from "../_services";
    /* eslint-disable no-debugger */

    export default {
        name: "ResumenCorta",
        props: ['referencia'],
        data() {
            return {
                pagarOk:false,
                categorias:[],
                pagaInscrito:'',
                pagadorInscrito: {},
                tpv: null,
                pagaAnonimo: {
                    nombre:'',
                    dni:'',
                    email:''
                },
                hoy: moment(),
                corte: moment('2020-01-16'),
                pagador: {
                    persona: null,
                    referencia: this.referencia,
                    corredor: ''
                },
                nombreRules: [
                    v => !!v || 'El nombre es necesario',
                    v => (v && v.length >= 10) || 'El nombre debe de tener por lo menos 10 carácteres'
                ],
                dniRules: [
                    v => !!v || 'El DNI es necesario',
                    v => (v && v.length <= 9) || 'El DNI tiene debe de ser 12345678A'
                ],
                emailRules: [
                    v => !!v || 'El correo elecrónico es necesario',
                    v => /.+@.+\..+/.test(v) || 'Debe de tener un formato correcto'
                ]
            }
        },
        created() {
            this.categorias = cat.siete
            if(this.$store.state.referencia === null)
                this.addReference(this.referencia)
            if (this.$store.state.inscritos.length == 1) {
                this.pagarOk = true
                this.pagador.persona = this.$store.state.inscritos[0]
                this.pagador.corredor = "SI"
            }
            insService.getTpv(this.referencia).then( rdo => {
                this.tpv = rdo
            })
        },
        computed: {
            getInscritos() {
                return this.$store.state.inscritos
            },
            pagadores() {
                return this.$store.state.inscritos.filter( persona => persona.menor !== 'SI' )
            }

        },
        methods: {
            ...mapActions(['addReference']),
            calcularTotal() {
                let total = 0.0
                this.$store.state.inscritos.forEach( (p) => {
                    if(p.menor == 'SI'){
                        total = total + 7
                    }else{
                        if(p.socio == 'SI')
                            total = total + 12.50
                        else if (this.hoy > this.corte)
                            total = total + 20.00
                        else if(p.camiseta == 'SI')
                            total = total + 16.00
                        else
                            total = total + 12.50
                    }


                })
                return total
            },
            calcularParcial(dni) {
                let parcial = 0.0
                let p = this.$store.state.inscritos.find( (a) => {
                    if (a.dni == dni)
                        return a
                } )

                if(p.socio == 'SI')
                    parcial =  12.50
                else if (this.hoy > this.corte)
                    parcial = 18.00
                else if(p.camiseta == 'SI')
                    parcial = 16.00
                else
                    parcial = 12.50

                if (p.menor == 'SI') parcial = 7

                return parcial
            },
            getCategoria(categoria) {
                return this.categorias.filter( cat => cat.id == categoria)[0]
            },
            cambiaModo() {
                if (this.pagaInscrito === 'NO') {
                    this.pagador.persona = null
                    this.pagarOk = false
                    this.pagador.corredor = 'NO'
                }else {
                    this.pagador.corredor = 'SI'
                }
            },
            establecePagador() {
                // Mandar los datos del pagador al server y pagar
                if (this.pagador.persona) this.pagarOk = true; else this.pagarOk = false;
            },

            pagar() {
                //hacia el TPV

                insService.setPagador(this.pagador).then( rdo => {
                    //eslint-disable-next-line

                    if(rdo.pagador_id) {
                        this.$refs.frmPago.submit()
                    }
                })

            },

            otroPagador () {
                if (this.$refs.form.validate()) {
                    //Mandar los datos del pagador al server y pagar
                    this.pagador.persona = this.pagaAnonimo
                    this.pagarOk = true
                }else this.pagarOk = false
            },
            volver() {
                this.$router.go(-1)
            }
        }

    }
</script>